<template>
  <div class="modal withdraw-modal success-create-modal">
    <div class="overlay"  @click="$parent.closeSuccessCreateModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="modal-head">
          <img class="close" @click="$parent.closeSuccessCreateModal" src="./../images/close.svg"/>
          <div class="title">{{ $t('Your offer succesfuly sent') }}</div>
        </div>
        <div class="modal-body">
          <div class="desc">
            {{ $t('We will contact you by e-mail within 3 business days') }}
          </div>
          <button class="button" @click="$parent.closeSuccessCreateModal">
            <span>[ {{ $t('OK') }} ]</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SuccessCreateModal',
  props: [],
  components: {
   
  },
  data: function() {
    return {
     
    }
  },
  methods: {

  }
}
</script>